export class PerformerUserContragent {
    performerUserId: number;
    performerUserName: string;
    performerUserGroupId: number;
    performerUserGroupName: string;
    contragentId: number;
    isMembershipDefaultUser: boolean;

    oldPerformerUserGroupId: number;
    isNew: boolean;
}